var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sheet-settings" },
    [
      _c("section", { staticClass: "card" }, [
        _c("div", { staticClass: "card-content" }, [
          _c("form", { attrs: { disabled: _vm.sheet.closed } }, [
            _c("div", { staticClass: "card-body row" }, [
              _c(
                "fieldset",
                {
                  staticClass: "col-md-6",
                  attrs: { disabled: _vm.anonymousMode && _vm.shareEnabled }
                },
                [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", {
                      directives: [
                        {
                          name: "i18n",
                          rawName: "v-i18n",
                          value: "sheet_settings_sheetTitle",
                          expression: "'sheet_settings_sheetTitle'"
                        }
                      ],
                      staticClass: "form-control-label"
                    }),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.name,
                          expression: "name"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { disabled: _vm.sheet.closed },
                      domProps: { value: _vm.name },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.name = $event.target.value
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _vm.anonymousMode
                    ? _c("div", { staticClass: "form-group" }, [
                        _c("label", {
                          directives: [
                            {
                              name: "i18n",
                              rawName: "v-i18n",
                              value: "book_settings_currency",
                              expression: "'book_settings_currency'"
                            }
                          ],
                          staticClass: "form-control-label"
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.currency,
                              expression: "currency"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { required: "" },
                          domProps: { value: _vm.currency },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.currency = $event.target.value
                            }
                          }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.anonymousMode
                    ? _c("div", [
                        _c("div", { staticClass: "form-check" }, [
                          _c("label", { staticClass: "form-check-label" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.shareEnabled,
                                  expression: "shareEnabled"
                                }
                              ],
                              staticClass: "form-check-input",
                              attrs: { type: "checkbox" },
                              domProps: {
                                checked: Array.isArray(_vm.shareEnabled)
                                  ? _vm._i(_vm.shareEnabled, null) > -1
                                  : _vm.shareEnabled
                              },
                              on: {
                                change: function($event) {
                                  var $$a = _vm.shareEnabled,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.shareEnabled = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.shareEnabled = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.shareEnabled = $$c
                                  }
                                }
                              }
                            }),
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t\t" +
                                _vm._s(
                                  _vm.$formatMessage(
                                    "sheet_share_enableSharing"
                                  )
                                ) +
                                "\n\t\t\t\t\t\t\t\t"
                            )
                          ]),
                          _vm._v(" "),
                          _c("small", {
                            directives: [
                              {
                                name: "i18n",
                                rawName: "v-i18n",
                                value: "sheet_share_enableSharing_tip",
                                expression: "'sheet_share_enableSharing_tip'"
                              }
                            ],
                            staticClass: "form-text text-muted"
                          })
                        ]),
                        _vm._v(" "),
                        _c(
                          "fieldset",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.shareEnabled,
                                expression: "shareEnabled"
                              }
                            ],
                            attrs: { disabled: !_vm.shareEnabled }
                          },
                          [
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", {
                                directives: [
                                  {
                                    name: "i18n",
                                    rawName: "v-i18n",
                                    value: "sheet_share_linkSheet",
                                    expression: "'sheet_share_linkSheet'"
                                  }
                                ],
                                attrs: { for: "sheet-share-url" }
                              }),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.shareUrl,
                                    expression: "shareUrl"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  id: "sheet-share-url",
                                  readonly: "readonly"
                                },
                                domProps: { value: _vm.shareUrl },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.shareUrl = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("small", {
                                directives: [
                                  {
                                    name: "i18n",
                                    rawName: "v-i18n",
                                    value: "sheet_share_linkSheet_tip",
                                    expression: "'sheet_share_linkSheet_tip'"
                                  }
                                ],
                                staticClass: "form-text text-muted"
                              })
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-group" }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.shareMode,
                                      expression: "shareMode"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  on: {
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.shareMode = $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    }
                                  }
                                },
                                [
                                  _c("option", {
                                    directives: [
                                      {
                                        name: "i18n",
                                        rawName: "v-i18n",
                                        value: "sheet_share_mode_view",
                                        expression: "'sheet_share_mode_view'"
                                      }
                                    ],
                                    attrs: { value: "1" }
                                  }),
                                  _vm._v(" "),
                                  _c("option", {
                                    directives: [
                                      {
                                        name: "i18n",
                                        rawName: "v-i18n",
                                        value: "sheet_share_mode_edit",
                                        expression: "'sheet_share_mode_edit'"
                                      }
                                    ],
                                    attrs: { value: "2" }
                                  })
                                ]
                              )
                            ])
                          ]
                        )
                      ])
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _vm.split
                ? _c(
                    "fieldset",
                    {
                      staticClass: "col-md-6",
                      attrs: {
                        disabled:
                          (_vm.shareEnabled && _vm.anonymousMode) ||
                          _vm.sheet.closed
                      }
                    },
                    [
                      _c("h4", {
                        directives: [
                          {
                            name: "i18n",
                            rawName: "v-i18n",
                            value: "sheet_settings_split_title",
                            expression: "'sheet_settings_split_title'"
                          }
                        ]
                      }),
                      _vm._v(" "),
                      _c("small", {
                        directives: [
                          {
                            name: "i18n",
                            rawName: "v-i18n",
                            value: "sheet_settings_split_help",
                            expression: "'sheet_settings_split_help'"
                          }
                        ],
                        staticClass: "form-text text-muted"
                      }),
                      _vm._v(" "),
                      _c("input-split", {
                        attrs: {
                          split: _vm.split,
                          sheet: _vm.sheet,
                          disabled: _vm.sheet.closed,
                          showCheckbox: false
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _vm.sheet.isOpen && !(_vm.shareEnabled && _vm.anonymousMode)
              ? _c("div", { staticClass: "card-footer" }, [
                  _c("button", {
                    directives: [
                      {
                        name: "i18n",
                        rawName: "v-i18n",
                        value: "save",
                        expression: "'save'"
                      }
                    ],
                    staticClass: "card-link",
                    attrs: { type: "button", disabled: _vm.cannotSubmit },
                    on: { click: _vm.saveSheet }
                  })
                ])
              : _vm._e()
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.sheet.id && !(_vm.anonymousMode && _vm.shareEnabled)
        ? _c("section", { staticClass: "participants" }, [
            _c("div", { staticClass: "row" }, [
              _c("h3", {
                directives: [
                  {
                    name: "i18n",
                    rawName: "v-i18n",
                    value: "sheet_settings_sheeters",
                    expression: "'sheet_settings_sheeters'"
                  }
                ],
                staticClass: "col-8"
              }),
              _vm._v(" "),
              !_vm.sheet.closed
                ? _c("div", { staticClass: "col-4 text-right" }, [
                    _c("button", {
                      directives: [
                        {
                          name: "i18n",
                          rawName: "v-i18n",
                          value: "add",
                          expression: "'add'"
                        }
                      ],
                      staticClass: "btn btn-primary",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          _vm.$emit("addParticipants")
                        }
                      }
                    })
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "row margin-top" },
              _vm._l(_vm.sortedItems, function(item) {
                return _c(
                  "div",
                  { key: item.sheeter.id, staticClass: "col-md-6" },
                  [
                    _c(
                      "card",
                      { staticClass: "card-avatar" },
                      [
                        _c("avatar", { attrs: { booker: item.booker } }),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "h4",
                            {
                              staticClass:
                                "col-6 no-margin text-nowrap text-truncate",
                              attrs: { title: item.booker.name }
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t" + _vm._s(item.booker.name)
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-6 text-secondary" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t∑ " +
                                _vm._s(
                                  _vm._f("format-currency")(
                                    item.sumExpenses,
                                    _vm.currency
                                  )
                                ) +
                                "\n\t\t\t\t\t\t"
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "card-footer",
                            attrs: { slot: "footer" },
                            slot: "footer"
                          },
                          [
                            _vm.anonymousMode
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "card-link",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function($event) {
                                        _vm.openBookerNameModal(item.booker)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm._f("format-message")("rename")
                                        ) +
                                        "\n\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !item.isMyself
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "card-link",
                                    attrs: {
                                      type: "button",
                                      title:
                                        item.sumExpenses > 0
                                          ? _vm.$formatMessage(
                                              "sheeter_cannotRemove"
                                            )
                                          : "",
                                      disabled:
                                        _vm.sheet.closed ||
                                        item.sumExpenses > 0 ||
                                        _vm.removingChild
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.removeSheeter(item.sheeter)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm._f("format-message")("delete")
                                        ) +
                                        "\n\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              })
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "modal",
        {
          ref: "modalBookerName",
          attrs: {
            title: "booker_changeName_modal_title",
            "modal-class": "modal-booker-name",
            disabled: _vm.renamingBooker,
            applyDisabled: !_vm.editedBookerName
          },
          on: { apply: _vm.applyBookerName }
        },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.editedBookerName,
                expression: "editedBookerName"
              }
            ],
            ref: "inputBookerName",
            staticClass: "form-control",
            attrs: { type: "text" },
            domProps: { value: _vm.editedBookerName },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.editedBookerName = $event.target.value
              }
            }
          })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e7a03bfa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e7a03bfa","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/ui/sheet-settings.vue
// module id = jl9l
// module chunks = 3